import { defineMessages } from 'react-intl'

const scope = `modules.purchasing.features.renamePOCustomField.presenters.editablePOCustomFieldTextFieldPresenter`

export default defineMessages({
  warningTitle: {
    id: `${scope}.warningTitle`,
    defaultMessage: 'Warning',
  },
  errorTitle: {
    id: `${scope}.errorTitle`,
    defaultMessage: 'Error',
  },
  duplicateNameWarning: {
    id: `${scope}.duplicateNameWarning`,
    defaultMessage: 'Purchase order custom field names must be unique.',
  },
  emptyNameWarning: {
    id: `${scope}.emptyNameWarning`,
    defaultMessage: 'Field description cannot be empty',
  },
  errorFallback: {
    id: `${scope}.errorFallback`,
    defaultMessage: 'Failed to rename the custom field.',
  },
})
